<template>
    <div>
        <h1 class="display-heading mb-3">Check In Registered Patient</h1>

        <div class="mb-5">
            <tab-view :tabs="tabs" :activeTab.sync="activeTab">

                <template v-if="activeTab===0">
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-right">New I/C Number</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" name="ic" v-mask="'######-##-####'" placeholder="E.g. 123456-78-9123" v-model="ic" v-on:keyup.enter="checkDetails">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-right">Other Identity Number</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" name="ic" v-model="otherIc" v-on:keyup.enter="checkDetails">
                        </div>
                    </div>
                </template>

                <template v-if="activeTab===1">
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-right">Patient Name</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control"  name="full name" v-model="name" v-on:keyup.enter="checkDetails">
                        </div>
                        <!-- <div class="col">
                            <i class="fas fa-long-arrow-alt-left"></i> Fong, please use this field first, the other fields are not ready yet.
                        </div> -->
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-right">Postcode</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control"  name="postcode" v-model="postcode" v-on:keyup.enter="checkDetails">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label text-right">Birth Date</label>
                        <div class="col-md-4">
                            <input type="text" name="birthDate"
                                    v-model="dob"
                                    v-mask="'##/##/####'"
                                    placeholder="DD/MM/YYYY"
                                    :class="{
                                    'form-control': true,
                                }" />
                        </div>
                    </div>
                </template>

                <div v-if="searchError" class="form-group row">
                    <div class="col-md-4 offset-md-3">
                        <span style="color:red;">{{ searchError }}</span>
                    </div>
                </div>

                <div v-if="isSearch" class="form-group row">
                    <div class="col-md-4 offset-md-3">
                        <template v-if="isSearchLoading">
                            <i class="fas fa-spinner fa-spin mr-2"></i> Checking patient details...
                        </template>
                        <template v-else>
                            {{patientFoundMessage}}
                        </template>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-4 offset-md-3">
                        <button @click="checkDetails" class="btn btn-primary btn-primary-insv">Search Patient</button>
                    </div>
                </div>
            </tab-view>
        </div>
        <template v-if="isResult && isPatientFound">
            <div class="card mb-3">
                <div class="card-header">Patient Details</div>
                <div class="card-body">
                    <div v-if="!isPatientFound" class="mb-3">
                        <p>{{isPatientFound ? 'Patient is eligible.': 'Patient is not eligible.'}}</p>
                    </div>

                    <div class="mb-3">
                        <table class="table table-sm table-bordered">
                            <colgroup>
                                <col width="50">
                                <col width="200">
                                <col>
                                <col width="200">
                                <col width="180">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <!-- <th>Full Name</th>
                                    <th>IC Number</th>
                                    <th>Phone Number</th> -->
                                    <th>Details</th>
                                    <th>Address</th>
                                    <!-- <th>Postcode</th> -->
                                    <th>Company</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(p, index) in patientList">
                                    <tr :key="index">
                                        <td>
                                            {{index+1}}
                                        </td>
                                        <td>
                                            <div>
                                                <div>
                                                    <span class="label">Name</span> : {{ p.name }}
                                                </div>
                                                <div>
                                                    <span class="label">IC</span> : {{p.icNumber ? p.icNumber: '-'}}
                                                </div>
                                                <div>
                                                    <span class="label">Phone</span> : {{p.phoneNumber ? p.phoneNumber: '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="p.address">{{ p.address }},</div>
                                            <div v-if="p.address2">{{ p.address2 }},</div>
                                            <div v-if="p.postcode">{{ p.postcode }}</div>
                                        </td>
                                        <td>
                                            <template v-if="p.companies.length === 0">
                                                -
                                            </template>
                                            <template v-else>
                                                <div v-for="(companyName, companyIndex) in p.companies" :key="companyIndex">
                                                    {{ companyIndex + 1 }}. {{ companyName }}
                                                </div>
                                            </template>

                                            <div v-if="p.isSelfPayingCustomer" class="mt-3">
                                                <span class="badge text-nowrap badge-danger">
                                                    Cash Paying Customer
                                                </span>
                                            </div>
                                            <!-- <div v-if="p.company">
                                                <div>
                                                    <span class="label">Company</span> : {{p.company ? p.company: '-'}}
                                                </div>
                                                <div>
                                                    <span class="label">Credit Limit</span> : {{p.company ? p.companyCreditUsage + ' / ' + p.companyCreditLimit : '-'}}
                                                </div>
                                            </div>
                                            <div v-else>
                                                -
                                            </div> -->
                                        </td>
                                        <td>
                                            <div>
                                                <button @click="register(p.patientId)" class="btn btn-sm btn-primary btn-primary-insv form-control">Check In Patient</button>
                                            </div>
                                            <div class="mt-3" v-if="p.canPrescribeMedicine">
                                                <button @click="newPrescription(p.patientId)" class="btn btn-sm btn-info btn-primary-insv form-control">Prescribe Medicine</button>
                                            </div>
                                            <div class="mt-3">
                                                <button @click="removeFromList(p.patientId)" class="btn btn-sm btn-danger btn-primary-insv form-control">Delete</button>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <popup-model ref="notePopup" :hasCloseButton="false" title="Note">
            <template slot="content">
                <div class="text-danger">
                    <p>
                        Some employees or individual patients requiring cash payments, please click "Dispensing and Payments" menu to confirm the payable amount <b>BEFORE</b> patient can leave your clinic.
                    </p>
                    <p>
                        Digital Savvy shall not responsible for any clinic's financial losses due to the delay or inaction of this patient-check-out step.
                    </p>
                </div>
            </template>
            <template slot="footer">
                <div class="text-left">
                <button class="btn btn-primary btn-primary-insv" @click="dismissNote">
                    Understand
                </button>
            </div>
            </template>
        </popup-model>
    </div>
</template>

<script>
import { convertDateToIso8601 } from '@/utilities';
import tabView from '@/components/tab-view';
import popupModel from '@/components/popup-modal';

import { mask } from 'vue-the-mask';
export default {
    'components': {
        tabView,
        popupModel
    },
    'directives': { mask },
    'computed': {
        patientFoundMessage () {
            return this.isPatientFound ? 'Please double check the patient details and register the patient for consultation. ' : 'No patient details found!';
        },
        icPassed () {
            return (this.$route.query && this.$route.query.ic) ? this.$route.query.ic : '';
        },
        namePassed () {
            return (this.$route.query && this.$route.query.name) ? this.$route.query.name : '';
        }
    },
    data () {
        return {
            'tabs': ['Search by IC', 'Search by Others'],
            'activeTab': 0,
            'ic': '',
            'otherIc': '',
            'name': '',
            'postcode': '',
            'dob': '',
            'isSearch': false,
            'isSearchLoading': false,
            'isPatientFound': false,
            'patientList': [],
            'searchError': '',
            'customerDetails': {
                'fullName': '',
                'userId': '',
                'dependents': [],
                'spendingLimit': 0,
                'currentSpending': 0
            },
            'customerCompany': {

            },
            'createNewVisitForm': {
                'userId': '',
                'dependentId': '',
                'clinicPatientQueueNumber': ''
            },
            'isResult': false
        };
    },
    mounted () {
        if (this.icPassed) {
            this.ic = this.icPassed;
        }

        if (this.namePassed) {
            this.name = this.namePassed;
        }

        if (this.icPassed || this.namePassed) {
            this.checkDetails();
        }
    },
    'methods': {
        checkDetails () {
            // Validation
            if (this.activeTab === 0) {
                if (!this.ic && !this.otherIc) {
                    this.searchError = 'At least one Identification Number is required!';
                    return;
                }
            } else {
                let numberOfInputs = 0;
                if (this.name) {
                    numberOfInputs++;
                }
                if (this.postcode) {
                    numberOfInputs++;
                }
                if (this.dob) {
                    numberOfInputs++;
                }

                if (numberOfInputs < 2) {
                    this.searchError = 'At least 2 fields are required!';
                    return;
                }
            }

            this.searchError = '';
            this.isSearch = true;
            this.isSearchLoading = true;

            this.axios.post('Clinic/CheckPatientDetails', {
                'fullName': this.name,
                'dateOfBirth': this.dob ? convertDateToIso8601(this.dob) : null,
                'icNumber': this.ic,
                'otherIcNumber': this.otherIc,
                'postCode': this.postcode
            }).then(({ data }) => {
                this.isResult = true;
                this.isSearchLoading = false;
                let userData = data.data;

                if (userData.length > 0) {
                    this.isPatientFound = true;

                    this.patientList = userData;
                } else {
                    this.isPatientFound = false;
                }
            });

            // this.axios.post(`Clinic/CheckEligible?ic=${this.ic}`).then(({ data }) => {
            //     this.isResult = true;
            //     this.isSearchLoading = false;

            //     let userData = data.data;

            //     this.isPatientFound = userData.isEligible;

            //     if (userData.isEligible) {
            //         this.customerDetails.fullName = userData.fullName;
            //         this.customerDetails.userId = userData.userId;
            //         this.customerDetails.spendingLimit = userData.spendingLimit.spendingLimit;
            //         this.customerCompany.currentSpending = userData.spendingLimit.currentSpending;
            //     }
            // });
        },
        register (patientId) {
            this.axios.post('Clinic/CheckInRegisteredPatient', {
                'patientId': patientId
            }).then(() => {
                this.$refs.notePopup.show();
            });
        },
        dismissNote () {
            this.$refs.notePopup.hide(() => {
                this.$router.push({
                    'name': 'clinic-patient-queue'
                });
            });
        },
        removeFromList (patientId) {
            const patientIndex = this.patientList.findIndex(patient => patient.patientId === patientId);

            this.patientList.splice(patientIndex, 1);
        },
        newPrescription (patientId) {
            this.$router.push({
                'name': 'clinic-new-prescription',
                'params': {
                    'patientId': patientId
                }
            });
        }
    },
    'watch': {
        activeTab () {
            this.ic = '';
            this.name = '';
            this.dob = '';
            this.postcode = '';
            this.searchError = '';
        }
    }
};

</script>

<style scoped>
.label {
    /* margin-right: 10px; */
    font-weight: 500;
    font-style: italic;
}
.hidden-text {

}
</style>
